import React from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import "../../components/Wedding/wedding.css";
import heroImage from "../../assets/img/wedding-hero.jpg";
import envelopeImage from "../../assets/img/wedding-envelope-burgundy.png";
import monogram from "../../assets/img/wedding-monogram-white.png";
import { coupleNames } from "../../components/Wedding/content";

export default function WeddingInvitation() {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <html lang="en" />
        <meta charSet="utf-8" />
        <title>{coupleNames} - Invitation</title>
        <meta name="description" content={`Open the wedding invitation for ${coupleNames}.`} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>

      <main className="wedding-invitation">
        <div
          className="wedding-invitation__background"
          style={{ backgroundImage: `url(${heroImage})` }}
        />
        <div className="wedding-invitation__overlay" />

        <section className="wedding-invitation__content" aria-label="Wedding invitation">
          <p className="wedding-invitation__eyebrow">YOU'VE GOT MAIL FROM</p>
          <h1 className="wedding-invitation__names">Hương &amp; Lượng</h1>
          <div className="wedding-invitation__open-area">
            <button
              type="button"
              className="wedding-invitation__envelope"
              onClick={() => navigate("/wedding/were-getting-married")}
              aria-label="Open wedding invitation"
            >
              <span className="wedding-invitation__envelope-art">
                <img className="wedding-invitation__envelope-paper" src={envelopeImage} alt="" />
                <img className="wedding-invitation__envelope-logo" src={monogram} alt="" />
              </span>
            </button>
            <p className="wedding-invitation__prompt">CLICK ENVELOPE TO OPEN</p>
          </div>
        </section>
      </main>
    </>
  );
}
